<template>
  <span class="pinsSpan" :id="'locationSpan-' + order_id">
    <!-- <i class="fas fa-map-marker-alt" style="color: #747474"></i> -->
    <font-awesome-icon
      icon="fa-sharp fa-solid fa-location-dot"
      style="color: #747474"
    />
    <span
      style="
        width: 20px;
        height: 0;
        display: inline-block;
        border-top: 2px solid #979797;
      "
    ></span
    ><font-awesome-icon
      icon="fa-sharp fa-solid fa-location-dot"
      style="color: #60a244"
    />
    <b-popover
      :target="'locationSpan-' + order_id"
      :container="'locationSpan-' + order_id"
      triggers="hover"
      placement="left"
    >
      <font-awesome-icon icon="fa-solid fa-circle" style="color: #747474" />
      {{ pickup }} <br />
      <font-awesome-icon icon="fa-solid fa-circle" style="color: #60a244" />
      {{ dropoff }}
    </b-popover>
  </span>
</template>
<script>
export default {
  name: "RouteLocationPins",
  props: ["order_id", "pickup", "dropoff"],
};
</script>


// WEBPACK FOOTER //
// src/components/doorder/orders/datatable_custom_cells/RouteLocationPins.vue